import { useEffect, useState } from 'react';

export function useRemoteCss(url) {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) return;

    let style = document.createElement('style');
    style.setAttribute('data-remote-css', url);
    document.head.appendChild(style);
    let isMounted = true;

    fetch(url)
      .then((r) => {
        if (!r.ok) throw new Error(`CSS fetch failed: ${r.status}`);
        return r.json(); // Changed from .text() to .json()
      })
      .then((data) => {
        if (!isMounted) return;
        //console.log('Fetched CSS content:', data.cssContent); // Now properly logs CSS
        style.textContent = data.cssContent; // Use the cssContent property
        setReady(true);
      })
      .catch((err) => {
        if (!isMounted) return;
        console.error('Failed to load CSS:', err);
        setError(err.message);
        document.head.removeChild(style);
      });

    return () => {
      isMounted = false;
      if (style && document.head.contains(style)) {
        document.head.removeChild(style);
      }
    };
  }, [url]);

  return { ready, error };
}